<template>
	<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.0007 6.69166C14.159 7.01666 14.584 7.325 14.9424 7.39166L17.0674 7.74167C18.4257 7.96667 18.7424 8.95 17.7674 9.93333L16.109 11.5917C15.834 11.8667 15.6757 12.4083 15.7674 12.8L16.2423 14.85C16.6173 16.4667 15.7507 17.1 14.3257 16.25L12.334 15.0667C11.9757 14.85 11.3757 14.85 11.0174 15.0667L9.02568 16.25C7.60068 17.0917 6.73402 16.4667 7.10902 14.85L7.58403 12.8C7.6757 12.4167 7.51736 11.875 7.24236 11.5917L5.58403 9.93333C4.60903 8.95833 4.9257 7.975 6.28403 7.74167L8.40902 7.39166C8.76735 7.33333 9.19236 7.01666 9.35069 6.69166L10.5257 4.34166C11.1507 3.06666 12.184 3.06666 12.8257 4.34166L14.0007 6.69166Z"
			:fill="color_prop" />
		<path
			d="M1.66675 4.79166C1.32508 4.79166 1.04175 4.50833 1.04175 4.16666C1.04175 3.825 1.32508 3.54166 1.66675 3.54166H6.66675C7.00841 3.54166 7.29175 3.825 7.29175 4.16666C7.29175 4.50833 7.00841 4.79166 6.66675 4.79166H1.66675Z"
			:fill="color_prop" />
		<path
			d="M1.66675 16.4583C1.32508 16.4583 1.04175 16.175 1.04175 15.8333C1.04175 15.4917 1.32508 15.2083 1.66675 15.2083H4.16675C4.50841 15.2083 4.79175 15.4917 4.79175 15.8333C4.79175 16.175 4.50841 16.4583 4.16675 16.4583H1.66675Z"
			:fill="color_prop" />
		<path
			d="M1.66675 10.625C1.32508 10.625 1.04175 10.3417 1.04175 10C1.04175 9.65833 1.32508 9.375 1.66675 9.375H2.50008C2.84175 9.375 3.12508 9.65833 3.12508 10C3.12508 10.3417 2.84175 10.625 2.50008 10.625H1.66675Z"
			:fill="color_prop" />
	</svg>
</template>

<script>
export default {

	name: 'IconVideoSlash',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1.25rem', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '1.25rem', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '#F8D62E',
		}
	},

	data() {
		return {
		}
	},

	computed: {
		width() {
			// return Number(this.width_prop.substr(0, this.width_prop.length - 2)) * this.sizeMultiplier_prop + this.width_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.width_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},

		height() {
			// return Number(this.height_prop.substr(0, this.height_prop.length - 2)) * this.sizeMultiplier_prop + this.height_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.height_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},
	},

	methods: {
		// extract value and unit from a string. px, em, rem, %
		extractValueAndUnit(input) {
			const regex = /^([\d.]+)(px|em|rem|%)$/ // Matches numeric values with units
			const match = input.match(regex)

			if (match) {
				const value = parseFloat(match[1]) // Convert numeric part to a number
				const unit = match[2] // Extract unit part
				return { value, unit }
			}

			return { value: 0, unit: 'px' } // Default value
		}
	}
}
</script>

<style lang="css" scoped></style>